'use client';

import ControlledButton from '@umodeapporg/ui/components/Form/ControlledButton';
import ControlledTextarea, { TTextareaResize } from '@umodeapporg/ui/components/Form/ControlledTextarea';
import ControlledTooltip from '@umodeapporg/ui/components/UI/ControlledTooltip';
import { MaterialSymbol } from '@umodeapporg/ui/components/UI/MaterialSymbol';
import { useTranslation } from 'react-i18next';

const TEXTAREA_RESIZE: TTextareaResize = 'none';

interface IAgenteComposerProps {
  value: string;
  onChange: (value: string) => void;
  onEnviar: () => Promise<void>;
  loading: boolean;
  /** Lifts the tooltip above a drawer, which stacks over the default tooltip layer. */
  tooltipClassName?: string;
}

/** Message input shared by the page and the side panel: Enter sends, Shift+Enter breaks the line. */
export function AgenteComposer({ value, onChange, onEnviar, loading, tooltipClassName }: IAgenteComposerProps) {
  const { t } = useTranslation('common');

  const podeEnviar = value.trim() !== '' && !loading;

  const handleKeyDown = async (event: React.KeyboardEvent<HTMLTextAreaElement>): Promise<void> => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      if (podeEnviar) {
        await onEnviar();
      }
    }
  };

  return (
    <div className="flex items-end gap-2">
      <ControlledTextarea
        label={t('agente.placeholder')}
        rows={1}
        resize={TEXTAREA_RESIZE}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={handleKeyDown}
        className="max-h-[120px]"
        containerClassName="flex-1"
      />
      <ControlledTooltip content={t('agente.enviar')} className={tooltipClassName}>
        <ControlledButton size="sm" className="shrink-0 px-3 py-2.5" disabled={!podeEnviar} onClick={onEnviar}>
          <MaterialSymbol icon="send" size={18} />
        </ControlledButton>
      </ControlledTooltip>
    </div>
  );
}
